import React, { useState } from "react";
import Image from "next/image";

const UspShortageDesk: React.FC = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      {/* desktop */}
      <div className="md:block hidden w-full justify-center items-center md:pt-[10px] pt-[32px] md:pb-[40px] pb-[32px] square_grid_bg bg-repeat bg-cover bg-[length:100% 100%]">
        <div className="mx-auto 2xl:px-0 xl:px-10 lg:p-0 md:block hidden relative">
          <div className="flex items-center md:mt-[35px] justify-center">
            {" "}
            <div
              className="relative cursor-pointer flex justify-center items-center"
              style={{ width: "960px", height: "506px" }}
              onClick={() => {
                openPopup("jLTrZfJfO_M");
              }}
            >
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/home/accountant_gif.webp"
                alt="MBE"
                className="cursor-pointer rounded-[15px]"
                width={960}
                height={559.535}
              />
              <div className="absolute flex items-center justify-center rounded-[15px] bg-[#00000067] bottom-0 left-0 w-full h-full">
                <Image
                  src="/newImages/MilesEducationWebsite-2024/cpa/work-in-us/play.png"
                  alt="Accountants"
                  className="cursor-pointer"
                  width={40}
                  height={40}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Popup */}
        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                id="huge-shortage-video-player"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>

      {/* mobile */}
      <div className="md:hidden block">
        <div
          className="bg-[#061A2F] p-[28px] relative"
          onClick={() => {
            openPopup("jLTrZfJfO_M");
          }}
        >
          <Image
            src="/images/accounting/usp/shortage.png"
            alt="Miles US Pathway Roadmap"
            className="mx-auto w-full cursor-pointer"
            width={480}
            height={252}
            priority
          />

          <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[32%]">
            <Image
              src="/images/accounting/usp/video-icon.png"
              alt="Accountants "
              className="cursor-pointer w-[50px]"
              width={110}
              height={110}
            />
          </div>
        </div>
        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspShortageDesk;
